import { ref, watch } from 'vue';
import { useWindowSize } from '@vueuse/core';
export const useResize = (fn?: Fn) => {
  const { width, height } = useWindowSize();
  const rootSize = ref(parseFloat(document.documentElement.style.fontSize));
  watch([() => width.value, () => height.value], () => {
    fn && fn();
  });

  /**
   * @desc postcss转化的px单位转化为实际px
   * @param {Number} px
   */
  function remPx2px(px) {
    return (px / 75) * rootSize.value;
  }

  function px2rem(px) {
    return px / 75;
  }

  return {
    windowWidth: width,
    windowHeight: height,
    rootSize,
    remPx2px,
    px2rem,
  };
};
